import setupShopifyAddToCartHook from './hook';

export default function productPageInjector() {
  setupShopifyAddToCartHook();
}
